<section class="sidenav-main full-height" fxLayout="column">
  <app-save-as-ep
    *ngIf="canShowSaveAsEp()"
    fxFlex="100"
    fxLayout="column"
    (closeSaveAsEp)="closeSaveAsEp()"
    (closeDrawingDetails)="cancel()"
    (epSaved)="onEpSaved()"
    [drawingConfigurationForEpDrawing]="drawingConfigurationForEpDrawing"
    [drawingName]="drawing.name"
    [drawingDimensionsInPx]="drawing?.dimensionsInPixels"
    [form]="saveAsEpForm"
  ></app-save-as-ep>
  <ng-container *ngIf="!canShowSaveAsEp()">
    <vdw-header [title]="'DESIGN_LIBRARY.LIBRARY.DESIGN_INFORMATION' | bmsTranslate" svgIcon="info-full-blue" [canShowClose]="true" (closeEvent)="cancel()">
      <ng-container *ngIf="canShowReplaceImageButton()">
        <ng-template [appHasPermission]="texeditWritePermission">
          <button appDataCy="replace-image" mat-flat-button class="add-new" color="primary" (click)="drawingImageReplaceImageInput.click()">
            {{ 'DESIGN_LIBRARY.LIBRARY.REPLACE_IMAGE' | bmsTranslate }}
          </button>
          <input #drawingImageReplaceImageInput multiple type="file" [attr.accept]="allowedFileExtensionForFiles" (change)="onDrawingReplaceImageFileChange($event.target?.files)" />
        </ng-template>
      </ng-container>
    </vdw-header>
    <article fxFlex="2 0 0px" fxLayout="column">
      <div fxFlex="100" fxLayout="column" fxLayoutAlign="start">
        <div *ngIf="canDisplayDetails()" fxFlex fxLayoutAlign="start start" fxLayout="row" class="drawing-details-width">
          <app-edit-drawing-form
            #editForm
            fxFlex
            [drawing]="drawing"
            [drawingShapes]="drawingShapes"
            [disableAllFields]="disableAllFields"
            [productionScheduleDrawing]="productionScheduleDrawing"
            (saveAsEp)="openSaveAsEp($event)"
            [parameterFieldsDisabled]="isDrawingBeingUsed()"
            [scrollToConfiguration]="scrollToConfiguration"
          ></app-edit-drawing-form>
        </div>

        <ng-container *ngIf="canShowLabelForNoDrawingSelected()">
          <span class="no-data-selected-title">{{ 'DESIGN_LIBRARY.LIBRARY.WARNINGS.NO_DESIGN_SELECTED' | bmsTranslate }}</span>
        </ng-container>

        <app-progress-spinner fxFlex fxLayoutAlign="center center" *ngIf="canShowLoaderForDrawing()" [text]="'GENERAL.LOADING.LOADING' | bmsTranslate"></app-progress-spinner>
      </div>
    </article>

    <mat-toolbar *ngIf="canShowBMPToolbars()" fxFlex="initial" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="16px">
      <ng-template [appHasPermission]="texeditWritePermission">
        <button appDataCy="delete-design" mat-stroked-button (click)="onDelete()" *ngIf="!isDrawingBeingUsed()">
          {{ 'GENERAL.ACTIONS.DELETE' | bmsTranslate }}
        </button>
      </ng-template>

      <button appDataCy="cancel" mat-stroked-button (click)="cancel()">
        {{ 'GENERAL.ACTIONS.CANCEL' | bmsTranslate }}
      </button>

      <ng-template [appHasPermission]="texeditWritePermission">
        <div class="button-skeleton-wrapper raised-btn" *ngIf="isDrawingBeingUsed()">
          <button mat-stroked-button color="warn" (click)="openConflictsDialog()">
            <mat-icon svgIcon="error"></mat-icon>
            {{ 'TEXTILE_DATA.ALREADY_USED' | bmsTranslate }}
          </button>
        </div>
        <vdw-progress-button [disabled]="!canUpdateDrawing()" [inProgress]="saving" (progressClick)="updateDrawing()"></vdw-progress-button>
      </ng-template>
    </mat-toolbar>

    <mat-toolbar class="ep-tft-toolbar" *ngIf="canShowOtherToolbars()" fxFlex="initial" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="16px">
      <ng-template [appHasPermission]="openExternalPermission">
        <button
          mat-icon-button
          class="mat-icon-action-button-lg-with-border"
          (click)="onOpenCadCam($event.target)"
          [matTooltip]="'GENERAL.ACTIONS.OPEN_IN_CAD_CAM' | bmsTranslate"
          matTooltipPosition="above"
          id="buttonOpenCadCamProtocolKnownFocusWorkaround"
        >
          <mat-icon svgIcon="open-external"></mat-icon>
        </button>
      </ng-template>

      <ng-container *ngIf="isDrawingTypeEp()">
        <ng-template [appHasPermission]="texeditWritePermission">
          <a #downloadAnchor fxHide></a>
          <button mat-icon-button class="mat-icon-action-button-lg-with-border" (click)="onDownload()" [matTooltip]="'GENERAL.ACTIONS.DOWNLOAD' | bmsTranslate" matTooltipPosition="above">
            <mat-icon svgIcon="download-24px"></mat-icon>
          </button>
        </ng-template>
      </ng-container>

      <ng-template [appHasPermission]="texeditWritePermission">
        <button
          mat-icon-button
          class="mat-icon-action-button-lg-with-border"
          (click)="onDelete()"
          *ngIf="!isDrawingBeingUsed()"
          [matTooltip]="'GENERAL.ACTIONS.DELETE' | bmsTranslate"
          matTooltipPosition="above"
        >
          <mat-icon svgIcon="trash"></mat-icon>
        </button>
      </ng-template>

      <ng-template [appHasPermission]="texeditWritePermission">
        <div class="button-skeleton-wrapper raised-btn" *ngIf="isDrawingBeingUsed()">
          <button mat-stroked-button color="warn" (click)="openConflictsDialog()">
            <mat-icon svgIcon="error"></mat-icon>
            {{ 'TEXTILE_DATA.ALREADY_USED' | bmsTranslate }}
          </button>
        </div>
        <vdw-progress-button [disabled]="!canUpdateDrawing()" [inProgress]="saving" (progressClick)="updateDrawing()"></vdw-progress-button>
      </ng-template>
    </mat-toolbar>
  </ng-container>
</section>
